import { useState } from "react";
import JoinPolicyUI from "./JoinPolicy.presenter";
import { useModal } from "src/hooks/useModal";

const JoinContainer = () => {
  const {
    openTermsService,
    openPrivacyPolicy,
    openPaidTermsService,
    openInformationAgree,
    hideModal,
    joinPolicyModalState,
  } = useModal();
  // const [showMsgModal, setShowMsgModal] = useState<boolean>(false);
  // const [msgModalTitle, setMsgModalTitle] = useState<string>("");
  // const [msgModalBody, setMsgModalBody] = useState<string>("");
  const [showEcoPolicyHistory, setShowEcoPolicyHistory] =
    useState<boolean>(false);
  const [showWrapsodyPolicyHistory, setShowWrapsodyPolicyHistory] =
    useState<boolean>(false);

  const handleClickTab = (target: any) => {
    if (target === "tab1") openTermsService();
    else if (target === "tab2") openPrivacyPolicy();
    else if (target === "tab3") openPaidTermsService();
    else if (target === "tab4") openInformationAgree();
    document.querySelector(".modal-body")?.scroll({ top: 0 });
  };

  const showEcoHistoryContent = () => {
    setShowEcoPolicyHistory(true);
  };

  const showWrapsodyHistoryContent = () => {
    setShowWrapsodyPolicyHistory(true);
  };

  const hideEcoHistoryContent = () => {
    setShowEcoPolicyHistory(false);
  };

  const hideWrapsodyHistoryContent = () => {
    setShowWrapsodyPolicyHistory(false);
  };

  return (
    <JoinPolicyUI
      showPolicy={joinPolicyModalState.showPolicy}
      tabTarget={joinPolicyModalState.tabTarget}
      cancelButton={hideModal}
      handleClickTab={handleClickTab}
      showEcoPolicyHistory={showEcoPolicyHistory}
      showWrapsodyPolicyHistory={showWrapsodyPolicyHistory}
      showEcoHistoryContent={showEcoHistoryContent}
      hideEcoHistoryContent={hideEcoHistoryContent}
      showWrapsodyHistoryContent={showWrapsodyHistoryContent}
      hideWrapsodyHistoryContent={hideWrapsodyHistoryContent}
      privacyPolicyVersion={joinPolicyModalState.privacyPolicyVersion}
    />
  );
};

export default JoinContainer;
